/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface AnexoProps {
  nome: string | null;
  anexoBase64: string | null;
}

interface ParamsProps {
  idTipoResultadoTarefa: string | null | any;
  idEmpreendimento: string | null | any;
  observacoes: string | null | any;
  descricao: string | null | any;
  dataProgramadaRealizacaoTarefa: string | null | any;
  horaProgramadaRealizacaoTarefa: string | null | any;
  idMotivoDesqualificacaoLead: string | null | any;
  inserirTarefaNoOutlook: boolean;
  tokenAd: string | any;
  anexo: AnexoProps | null | any;
  idProfissao365: string | any;
  idade: string | any;
  bairro: string;
  codigoMotivo: string | any;
  idUsuarioEspecialista: string | any;
  idEmpreendimentoRegionalSul: string | any;
  idTemperaturaLead365: string | any;
  idObjetivoCompra?: string | null;
  solicitarPresencaEspecialista?: boolean;
}

interface Params {
  idTarefaLead: string;
  body: ParamsProps;
}

export function useConcluirTarefa(props: Params) {
  const registerData = async () => {
    const CONCLUIR_TAREFA = `${leadsWebEnviroment}/common/tarefas-leads/concluir/v1/${props?.idTarefaLead}`;
    return await instance.put(CONCLUIR_TAREFA, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["concluir_tarefa"],
    onSuccess: () => {
      toast.success("Tarefa concluída com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      console.log(error?.response);
      if (error?.response?.status >= 500) {
        toast.error(`Houve um erro: Status: ${error?.response?.status}`, {
          autoClose: 10000,
        });
      } else {
        const errorMessages = error.response.data.notifications.map(
          (item: any) => `\n${item?.message}\n`
        );

        toast.error(errorMessages.join(""), { autoClose: 10000 });
      }
    },
  });
  return query;
}
